import React, { useState, useRef } from 'react';
import { IconComponent } from '../components/reusable/simpleComponents';
import TriggersComponent from '../components/reusable/TriggersComponent';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../store';
import { APIState } from '../store/API/types';
import useClickOutside from '../hooks/useClickOutside';

const TriggersWrapperComponent = () => {
  const ref = useRef<HTMLDivElement>(null);

  const {globalTriggers} = useSelector<ApplicationState, APIState>(state => state.API);
  const [triggersOpened, setTriggersOpened] = useState(false);
  const dispatch = useDispatch();

  const closeTriggers = () => {
    setTriggersOpened(false);
  }

  const selectTrigger = (triggerId: string) => {
    dispatch({type: 'globalTrigger', triggerId});
    setTriggersOpened(false)
  };

  useClickOutside(ref, closeTriggers);

  return <div className="triggers-wrapper pos-rel" ref={ref}>
    <IconComponent classValue="triggers-icon pointer icon"
                   handler={(e: React.MouseEvent) => {
                     e.preventDefault();
                     e.stopPropagation();
                     setTriggersOpened(!triggersOpened);
                   }}
                   title="Global Triggers"
    />
    {
      triggersOpened && <TriggersComponent
        triggers={globalTriggers}
        onClick={selectTrigger}
        onClose={closeTriggers}
        title="Global Triggers"
      />
    }
  </div>;
}

export default TriggersWrapperComponent;